export default __webpack_public_path__ + "static/media/benefits_shadow.b150b501.svg";